import React, { useEffect, useState } from 'react'
import ConfirmationView from './components/ConfirmationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const Confirmation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('confirmation', 'Pay a Fine', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <ConfirmationView setIsError={setIsError} />
}

export default withTranslation('common')(Confirmation)
